import { Flex } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductList from "../../../components/AgencyComp/ProductComp/ProductList";
import ProductTable from "../../../components/AgencyComp/ProductComp/ProductTable";
import { fetchAgencyProducts, fetchAgencyProductsTable } from "../../../store/agencySlice";
import { fetchBankDashboard } from "../../../store/portfolioSlice";

const AgencyProduct = () => {
  const { products_list, products_loading,product_list_table_loading,product_list_table} = useSelector(
    (state) => state?.agency
  );
  const [param, setParam] = useState({
    page: 1,
    page_size: 10,

  })
  const { bankDashboard, bankDashboard_loading } = useSelector(state => state.portfolio);
  
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAgencyProducts());
    dispatch(fetchBankDashboard());
  }, [dispatch]);
  
  useEffect(() => {
    dispatch(fetchAgencyProductsTable(param))
  },[param])

  return (
    <Flex
      vertical
      className="agencyProductContainer"
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <ProductList products={products_list?.results} productsLoading={products_loading} banks={bankDashboard} banksLoading={bankDashboard_loading} />
      <ProductTable data={product_list_table} loading={product_list_table_loading} setParam={setParam} param={param} />
    </Flex>
  );
};

export default AgencyProduct;
